export default __webpack_public_path__ + "static/media/filter.53cad4da.svg";